import { IVehicle } from "../models/Vehicle";

/**
 * Where a lead's COD step stands on the workflow card.
 *
 * - done: a certificate of destruction has been issued.
 * - skipped: COD is marked as not required, so there is nothing to issue. Kept apart from done so
 *   staff can tell a skipped COD from an issued one at a glance.
 * - not_started: COD is required and no certificate has been issued yet.
 */
export type CodStepState = "done" | "skipped" | "not_started";

export function codStepState(vehicle: Pick<IVehicle, "codRequired" | "codConfirmedOn"> | null | undefined): CodStepState {
  // An issued certificate wins even if COD was later switched to not required - the COD still exists.
  if (vehicle?.codConfirmedOn) return "done";
  // No vehicle yet means no COD to issue, which the card has always treated as finished.
  if (!vehicle?.codRequired) return "skipped";
  return "not_started";
}

/** Done or skipped - nothing left to do for COD before the lead can be completed. */
export function isCodStepFinished(state: CodStepState) {
  return state !== "not_started";
}
